import { Component, OnInit } from "@angular/core";
import { NgxSpinnerService } from "ngx-spinner";
import { ActivatedRoute, Router } from "@angular/router";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { AnalyzeTripService } from "../../../services/analyze-trip.service";
import { toCamel } from "snake-camel";
import { ToolsService } from "src/app/services/migrate/tools.service";
import { STORAGE_KEY_CURRENT_USER } from "src/app/storageCore/constStorageKeys";
import storageX from "src/app/storageCore/storageX";

import { ManagerModel } from "src/app/models/manager-model";
@Component({
  selector: 'app-create-supervisor',
  templateUrl: './create-supervisor.component.html',
  styleUrls: ['./create-supervisor.component.scss']
})
export class CreateSupervisorComponent implements OnInit {
  public analyzeTripService: AnalyzeTripService;
  public supervisorSelect;
  public supervisorsFree: any = [];

  public supervisorForm: FormGroup;

  public errorMessage;

  ngOnInit(): void {
    this.supervisorForm = this.formBuilder.group(
      {
        selectUser: ["", Validators.required],
      },
    );

    this.loadDataElements();
  }

  constructor(
    private tools: ToolsService,
    private formBuilder: FormBuilder,
    private router: Router,
    private spinner: NgxSpinnerService,
    private activatedRoute: ActivatedRoute,
    analyzeTripService: AnalyzeTripService
  ) {
    this.analyzeTripService = analyzeTripService;
  }


  public async loadDataElements() {
    try {
      this.analyzeTripService
        .getBySupervisorFree()
        .subscribe((resp) => {
          this.supervisorsFree = toCamel(resp);
        });

      this.tools.builder().spinner.hide();
    } catch (error) {
      this.tools.builder().spinner.hide();
      throw new EvalError(error);
    }
  }


  public async submitForm(): Promise<void> {
    this.spinner.show();
    const values = this.supervisorForm.value;

    var supervisor: ManagerModel = new ManagerModel();
    supervisor.idUser = values.selectUser;
    supervisor.userCreateId = storageX
      .whereKeyIs(STORAGE_KEY_CURRENT_USER)
      .get()?.id;


    this.analyzeTripService
      .createSupervisor(
        supervisor
      )
      .subscribe((t) => {
        this.router.navigate(["/supervisor"]);
      });
  }
}

